/* eslint-disable unicorn/prefer-ternary */
/* eslint-disable unicorn/no-object-as-default-parameter */
import { api } from 'utils'
import { MENU } from 'utils/endpoints'

// se client-side -> prendo da localStorage
export const fetchMenu = (lang = 'it', isCachable) => {
  let payload = null
  const key = `menu-${lang}`

  if (typeof window !== 'undefined' && isCachable && localStorage.getItem(key)) {
    payload = { data: localStorage.getItem(key) }
  } else {
    payload = api.get(MENU, { params: { lang } })
  }

  return {
    type: 'FETCH_MENU',
    payload,
  }
}

export default function reducer(
  state = {
    menu: [],
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case 'FETCH_MENU_PENDING': {
      return { ...state, fetching: true }
    }
    case 'FETCH_MENU_REJECTED': {
      return { ...state, fetching: false, error: action.payload }
    }
    case 'FETCH_MENU_FULFILLED': {
      const lang = action.payload.config.params?.lang

      const menu = action.payload.data
      const key = `menu-${lang}`

      if (typeof window !== 'undefined') localStorage.setItem(key, action.payload.data)

      return {
        ...state,
        fetching: false,
        fetched: true,
        menu,
        lang,
      }
    }

    default: {
      return state
    }
  }
}
